import clsx from "clsx";

import MitreIcon from "./MitreIcon";

import styles from "./mitre.module.scss";
import { MitreAttackTechniqueWithSource } from "./MitreAttack";

type Props = {
  mitre?: Record<string, MitreAttackTechniqueWithSource[]>;
};

const MitreAttackTable = ({ mitre }: Props) => (
  <div className={clsx(styles.mitre_table)}>
    {Object.entries(mitre ?? {})?.map(([name, techniques]) => (
      <MitreIcon
        key={name}
        name={name}
        disabled={!techniques.length}
        techniques={techniques || []}
      />
    ))}
  </div>
);

export default MitreAttackTable;
